export const BASE_URL = "/admin";

/******** APPLICANTS **********/
export const MEMBERS_URL = `${BASE_URL}/members`;
export const SAVE_MEMBER = MEMBERS_URL;
export const VALIDATE_MEMBER_EMAIL = MEMBERS_URL + "/checkEmailExists";
export const GET_MEMBER = MEMBERS_URL;

/******** REGIONS **********/
export const REGIONS_URL = `/region/all`;

/******** COUNTRIES **********/
export const COUNTRIES_URL = `/country/all`;
export const COUNTRIES_BY_REGION_URL = `/country/by-region`;

/******** Notifications **********/
export const NOTIFICATIONS_URL = "/notifications";
export const GET_UNREAD_NOTIFICATIONS = `${NOTIFICATIONS_URL}/unread`;
export const GET_FIRST_TEN_NOTIFICATIONS= `${NOTIFICATIONS_URL}/unread/first-ten`;
export const MARK_ALL_NOTIFICATIONS_READ = `${NOTIFICATIONS_URL}/read-all`;
export const DELETE_ALL_NOTIFICATIONS = `${NOTIFICATIONS_URL}/delete-all`;
export const GET_UNREAD_COUNT = `${NOTIFICATIONS_URL}/unread-count`;

/******** Authentication **********/
export const USER_AUTHENTICATION_URL = "/auth";
export const USER_LOGIN_URL = `${USER_AUTHENTICATION_URL}/login`;
export const USER_REGISTER_URL = `${USER_AUTHENTICATION_URL}/register`;
export const VALIDATE_EMAIL = `${USER_AUTHENTICATION_URL}/checkEmail`;
export const GET_CURRENT_USER = `${USER_AUTHENTICATION_URL}/get-current-user`;
export const USER_LOGOUT = `${USER_AUTHENTICATION_URL}/logout`;

/******** USERS **********/
export const USERS_URL = "/users";
export const OTP_BASE = "/otp";
export const USER_FORGOT_PASS = `${OTP_BASE}/forgot-password`;
export const USER_CONFIRM_OTP = `${OTP_BASE}/confirm-otp`;
export const USER_RESET_PASS = `${OTP_BASE}/reset-password`;
export const DELETE_USER = `${USERS_URL}/delete`;
export const SAVE_USER = `${USERS_URL}/add`;
export const USERS_PLANNER_URL = `${USERS_URL}/allPlanners`;
export const UPDATE_USER = `${USERS_URL}/update`; // Remove the userId parameter from the base route
export const CHECK_PASSWORD = `${USERS_URL}/check-password`;
export const GET_USER_BY_ROLE = `${USERS_URL}/role`

/******** CATEGORIES **********/
export const CATEGORIES_URL = "/category"
export const GET_CATEGORIES_URL = `${CATEGORIES_URL}/all`
export const SAVE_CATEGORY = `${CATEGORIES_URL}/create`;
export const DELETE_CATEGORY = `${CATEGORIES_URL}/delete`;

/******** EXIT REQUETS *******/
export const EXIT_PLANS_FOR_APPROVAL = "/exit-plans/for-approval";
export const EXIT_REQUESTS="/exitRequest";
export const ADD_EXIT_REQUEST=`${EXIT_REQUESTS}/add`;
export const GET_EXIT_REQUEST=`${EXIT_REQUESTS}`;
export const GET_ALL_EXIT_REQUESTS=`${EXIT_REQUESTS}/all`; // Added this line for fetching all requests
export const DELETE_EXIT_REQUEST=`${EXIT_REQUESTS}/delete`;
export const UPDATE_EXIT_REQUEST = `${EXIT_REQUESTS}/update`;
export const CANCELED_EXIT_REQUESTS=`${EXIT_REQUESTS}/cancel`;
export const MY_CANCELED_EXIT_REQUESTS=`${EXIT_REQUESTS}/my-canceled`;
export const MY_EXIT_REQUESTS_REG=`${EXIT_REQUESTS}/my`;
export const ALL_EXIT_REQUESTS_REG=`${EXIT_REQUESTS}/all`;
export const PENDING_APPROVALS=`${EXIT_REQUESTS}/manager/pending-approvals`;
export const ASSIGNED_REQUESTS=`${EXIT_REQUESTS}/manager/assigned-requests`;
/* Excel export — each route mirrors the listing route directly above it, and takes the same
   filter payload so the file matches whatever the grid is filtered to. */
export const EXIT_REQUEST_EXPORT=`${EXIT_REQUESTS}/export`;
export const EXIT_REQUEST_EXPORT_ATTRIBUTES=`${EXIT_REQUEST_EXPORT}/attributes`;
export const ALL_EXIT_REQUESTS_EXPORT=`${EXIT_REQUEST_EXPORT}/all`;
export const MY_EXIT_REQUESTS_EXPORT=`${EXIT_REQUEST_EXPORT}/my`;
export const MY_RD_EXIT_REQUESTS_EXPORT=`${EXIT_REQUEST_EXPORT}/my/rd`;
export const ESCALATED_EXIT_REQUESTS_EXPORT=`${EXIT_REQUEST_EXPORT}/escalated`;
export const PDF_URL = "/pdf";
export const EXIT_REQUEST_PDF = `${PDF_URL}/exit-request`;

/******** EXEMPTION REQUESTS *******/
export const EXIT_PLANS = "/exit-plans";
export const MY_EXEMPTION_REQUESTS = `${EXIT_PLANS}/exemptions/my`;
export const REGULATORY_EXEMPTION_REQUESTS = `${EXIT_PLANS}/exemptions/regulatory`;
export const EXEMPTIONS_FOR_APPROVAL = `${EXIT_PLANS}/exemptions/for-approval`;
export const ALL_SUBMITTED_EXEMPTION_REQUESTS = `${EXIT_PLANS}/exemptions/all`;
export const EXIT_PLAN_BY_ID = (planId) => `${EXIT_PLANS}/${planId}`;
export const EXIT_PLAN_APPROVE = (planId) => `${EXIT_PLANS}/${planId}/approve`;
export const EXEMPTION_LOCAL_RISK_ASSESSMENT = (planId) => `${EXIT_PLANS}/${planId}/local-risk-assessment`;
export const EXEMPTION_REQUEST_PDF = `${PDF_URL}/exemption-request`;

/******** INGREDIENTS *******/
export const INGREDIENTS = "/ingredient";
export const GET_ALL_INGREDIENTS = `${INGREDIENTS}/all`;
export const SAVE_NEW_INGREDIENTS = `${INGREDIENTS}/save`;

/********* Chat **********/
export const AI_CHAT_URL = "/ai-bot";
export const AI_CHAT_ASK_URL = `${AI_CHAT_URL}/ask`;
export const AI_CHAT_CLEAR_CONTEXT_URL = `${AI_CHAT_URL}/clear-context`;


/******** Delegation Requests *******/
export const DELEGATION = "/delegation";
export const GET_DELEGATION_USERS = `${DELEGATION}/getUsers`;
export const REQUEST_DELEGATION = `${DELEGATION}/request`;
export const GET_MY_DELEGATION_REQUESTS = `${DELEGATION}/my-requests`;
export const RESPOND_TO_DELEGATION_REQUESTS = `${DELEGATION}/respond`;

/******** Extension Requests *******/
export const EXTENSION_REQUESTS = "/extension-requests";
export const REQUEST_EXTENSION = `${EXTENSION_REQUESTS}/request`;
export const RESPOND_TO_EXTENSION_REQUEST = `${EXTENSION_REQUESTS}/respond`;
export const GET_MY_EXTENSION_REQUESTS = `${EXTENSION_REQUESTS}/my-requests`;
export const GET_ACTIVE_EXTENSION_INFO = `${EXTENSION_REQUESTS}/assignment`;

/******** Exit Request Response Drafts *******/
export const EXIT_REQUEST_RESPONSE = "/exit-request-response";
export const RD_DRAFT_SAVE = `${EXIT_REQUEST_RESPONSE}/draft`;
export const RD_DRAFT_DELETE = `${EXIT_REQUEST_RESPONSE}/draft`;
export const RD_DRAFTS = `${EXIT_REQUEST_RESPONSE}/my-drafts`;
export const RD_HAS_DRAFT = `${EXIT_REQUEST_RESPONSE}/has-draft`;

/******** R&D Coordinator Response *******/
export const COORDINATOR_RESPONSE_SAVE = `${EXIT_REQUEST_RESPONSE}/coordinator`;
export const COORDINATOR_RESPONSE_SUBMIT = (id) => `${EXIT_REQUEST_RESPONSE}/coordinator/${id}/submit`;
export const COORDINATOR_RESPONSE_BY_ASSIGNMENT = (assignmentId) => `${EXIT_REQUEST_RESPONSE}/coordinator/by-assignment/${assignmentId}`;
export const COORDINATOR_USERS = `${USERS_URL}/role`; // Use GET_USER_BY_ROLE with roleName=RD_COORDINATOR

/******** Support Requests *******/
export const SUPPORT_REQUESTS = "/support-requests";
export const GET_SUPPORT_REQUESTS = SUPPORT_REQUESTS;
export const GET_SUPPORT_REQUEST_BY_ID = SUPPORT_REQUESTS;
export const CREATE_SUPPORT_REQUEST = SUPPORT_REQUESTS;
export const UPDATE_SUPPORT_REQUEST = SUPPORT_REQUESTS;
export const DELETE_SUPPORT_REQUEST = SUPPORT_REQUESTS;
export const GET_MY_SUPPORT_REQUESTS = `${SUPPORT_REQUESTS}/my-requests`;
export const GET_SUPPORT_REQUESTS_BY_EXIT_PLAN = `${SUPPORT_REQUESTS}/exit-plan`;
export const SUBMIT_SUPPORT_RESPONSE = `${SUPPORT_REQUESTS}/respond`;
export const REASSIGN_SUPPORT_REQUEST = `${SUPPORT_REQUESTS}/reassign`;
export const CHECK_USER_EMAIL = "/users/check-email";

/******** Escalation Requests *******/
export const ESCALATIONS = "/escalations";
export const ESCALATIONS_MANAGER = `${ESCALATIONS}/manager`;
export const ESCALATIONS_RD = `${ESCALATIONS}/rd`;

/******** Approver Requests *******/
export const REQUEST_APPROVER = (exitRequestId) => `/exitRequest/${exitRequestId}/request-approver`;
